import { useState } from "react";
import { toast } from "react-toastify";
import PendingCodesModal from "./PendingCodesModal";

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Đã copy danh sách mã");
  } catch {
    toast.warning("Trình duyệt chặn copy — hãy bôi đen danh sách rồi Ctrl+C");
  }
};

/**
 * Panel mã vận đơn đã quét: mỗi mã một dòng để copy; nút Chỉnh sửa mở popup bỏ mã khỏi danh sách chờ;
 * nút xác nhận tất cả (lúc này mới đổi trạng thái đơn).
 */
const ScannedCodesPanel = ({
  pendingLogs,
  confirmedCodes,
  confirmLabel,
  onConfirm,
  onRemove,
  confirmDisabled,
  confirming,
  confirmCount,
}) => {
  // Số mã có thể xác nhận (quét nhập tính thêm mã chưa tồn tại để tạo đơn).
  const confirmable = confirmCount ?? pendingLogs.length;
  const [tab, setTab] = useState("pending");
  const [editing, setEditing] = useState(false);
  const codes = tab === "pending" ? pendingLogs.map((log) => log.code) : confirmedCodes;
  const text = codes.join("\n");

  return (
    <div className="warehouse-codes card">
      <div className="card-header d-flex flex-wrap gap-2 align-items-center justify-content-between">
        <div className="btn-group btn-group-sm" role="group">
          <button
            type="button"
            className={`btn ${tab === "pending" ? "btn-success" : "btn-outline-success"}`}
            onClick={() => setTab("pending")}
          >
            Chờ xác nhận ({pendingLogs.length})
          </button>
          <button
            type="button"
            className={`btn ${tab === "confirmed" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setTab("confirmed")}
          >
            Đã xác nhận ({confirmedCodes.length})
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setEditing(true)}
            disabled={pendingLogs.length === 0}
            title="Chỉnh sửa danh sách mã chờ xác nhận"
          >
            Chỉnh sửa
          </button>
        </div>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => copyText(text)} disabled={!codes.length}>
          Copy
        </button>
      </div>
      <div className="card-body p-2">
        <textarea
          className="form-control warehouse-codes__text"
          readOnly
          value={text}
          rows={8}
          placeholder={tab === "pending" ? "Chưa có mã hợp lệ nào" : "Chưa xác nhận mã nào"}
          aria-label="Danh sách mã vận đơn, mỗi mã một dòng"
        />
      </div>
      {tab === "pending" && (
        <div className="card-footer">
          <button
            type="button"
            className="btn btn-success w-100 fw-bold"
            onClick={onConfirm}
            disabled={confirmDisabled || confirming || confirmable === 0}
          >
            {confirming ? "Đang xác nhận..." : `${confirmLabel} (${pendingLogs.length})`}
          </button>
        </div>
      )}
      <PendingCodesModal
        show={editing}
        onHide={() => setEditing(false)}
        pendingLogs={pendingLogs}
        onRemove={onRemove}
      />
    </div>
  );
};

export default ScannedCodesPanel;
